export const avatars = [
  '/assets/images/sales1.png',
  '/assets/images/sales2.png',
  '/assets/images/sales3.png',
];
